module.exports = __webpack_public_path__ + "img/1070.85209fde.gif";